module.exports = __webpack_public_path__ + "static/media/You & Me This Morning _ 4-30-2015.c9cd2acd.jpg";